import React, { useState, useEffect, useCallback } from "react";
import { useParams, Link } from "react-router-dom";
import Helmet from "react-helmet";
import axios from "axios";
import { MDBContainer, MDBNavbar, MDBNavbarBrand } from "mdb-react-ui-kit";
import Language from "../../Components/Languages";
import * as dataAdmin from "../../Data/AdminProprietaires.json";
import "../Activation/Activation.scss";
import "./AdminProprietaires.scss";

// Page d'administration /:lang/AdminProprietaires — reservee a l'admin : le
// SERVEUR le garantit (proprietairesListe / campagneEtat : bearer + compte admin,
// 401/403 sinon) ; le front se contente d'afficher « acces reserve ».
const fmt = (s, v) => s.replace(/\{(\w+)\}/g, (_, k) => (v[k] !== undefined ? v[k] : ""));
const nomDe = (p) => [p.first_name, p.last_name].filter(Boolean).join(" ") || p.email || `#${p.user_id}`;

const AdminProprietaires = () => {
  const { lang } = useParams();
  const T = dataAdmin.default[lang] || dataAdmin.default.en;
  const L = dataAdmin.default[lang] ? lang : "en";
  const [filtre, setFiltre] = useState("multi");
  const [q, setQ] = useState("");
  const [liste, setListe] = useState(null);
  const [etat, setEtat] = useState(null);
  const [refuse, setRefuse] = useState(false);
  const [msg, setMsg] = useState("");
  const [ajout, setAjout] = useState({ serial_num: "", email: "", motif: "" });
  const [page, setPage] = useState(1);
  const [sel, setSel] = useState({});          // device_id -> appareil (selection pour le retrait groupe)
  const [bulkUser, setBulkUser] = useState("");

  const charger = useCallback((f = filtre, recherche = q, pg = page) => {
    axios.get("/Back-end/proprietairesListe", { params: { filtre: f, q: recherche, pg } /* jamais « page » : c est le nom de route du Back-end */ })
      .then((r) => { setListe(r.data); setPage(pg); })
      .catch((e) => { if (e.response && [401, 403].includes(e.response.status)) setRefuse(true); else setListe({ status: false, raison: "RESEAU" }); });
  }, [filtre, q, page]);

  useEffect(() => {
    charger("multi", "", 1);
    axios.get("/Back-end/campagneEtat").then((r) => setEtat(r.data)).catch(() => {});
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const retirer = (a, p) => {
    const v = { nom: nomDe(p), sn: a.serial_num };
    if (!window.confirm(fmt(T.confirmRemove, v))) return;
    const envoyer = (confirmerDernier) =>
      axios.post("/Back-end/proprietaireRetirer", { device_id: a.device_id, user_id: p.user_id,
        motif: "page admin", confirmer_dernier: confirmerDernier })
        .then((r) => {
          const d = r.data || {};
          if (d.raison === "DERNIER_PROPRIETAIRE" && !confirmerDernier) {
            if (window.confirm(fmt(T.confirmLast, v))) envoyer(true);
            return;
          }
          setMsg(d.status ? T.removed : fmt(T.error, { code: d.raison }));
          charger();
        })
        .catch(() => setMsg(fmt(T.error, { code: "RESEAU" })));
    envoyer(false);
  };

  // Retrait GROUPE : un proprietaire (ex. distributeur) retire de tous les appareils
  // selectionnes ou il figure. Le dernier proprietaire n'est retire qu'apres une
  // seconde confirmation. Chaque retrait est journalise (RETRAIT_GROUPE).
  const selection = Object.values(sel);
  const proprietairesSel = {};
  selection.forEach((a) => a.proprietaires.forEach((p) => { proprietairesSel[p.user_id] = p; }));
  const retraitGroupe = () => {
    const p = proprietairesSel[bulkUser];
    if (!p) return;
    const ids = selection.filter((a) => a.proprietaires.some((x) => String(x.user_id) === String(bulkUser))).map((a) => a.device_id);
    const v = { nom: nomDe(p), n: ids.length };
    if (!window.confirm(fmt(T.confirmBulk, v))) return;
    const envoyer = (confirmer) => axios.post("/Back-end/proprietaireRetirerGroupe",
      { user_id: p.user_id, device_ids: ids, motif: "retrait groupe (page admin)", confirmer_dernier: confirmer })
      .then((r) => {
        const b = (r.data && r.data.bilan) || {};
        if (!confirmer && b.DERNIER_PROPRIETAIRE && window.confirm(fmt(T.confirmBulkLast, { nom: v.nom, n: b.DERNIER_PROPRIETAIRE }))) {
          return envoyer(true);
        }
        setMsg(fmt(T.bulkDone, { bilan: Object.entries(b).map(([k, n]) => `${k} ${n}`).join(", ") }));
        setSel({}); setBulkUser(""); charger();
      })
      .catch(() => setMsg(fmt(T.error, { code: "RESEAU" })));
    envoyer(false);
  };

  const ajouter = (e) => {
    e.preventDefault();
    axios.post("/Back-end/proprietaireAjouter", ajout)
      .then((r) => { const d = r.data || {}; setMsg(d.status ? T.added : fmt(T.error, { code: d.raison })); if (d.status) { setAjout({ serial_num: "", email: "", motif: "" }); charger(); } })
      .catch(() => setMsg(fmt(T.error, { code: "RESEAU" })));
  };

  const c = liste && liste.compteurs;
  return (
    <>
      <Helmet><title>{T.title} | MAD-UP Academy</title><meta name="robots" content="noindex" /></Helmet>
      <header>
        <MDBNavbar light bgColor="white" className="activer-nav">
          <MDBContainer fluid className="activer-nav__in admin-nav">
            <MDBNavbarBrand href={`/${L}/HomeAcademy`}><span className="activer-marque">MAD-UP <span>Academy</span></span></MDBNavbarBrand>
            <div className="d-flex"><Language /></div>
          </MDBContainer>
        </MDBNavbar>
      </header>
      <main className="activer admin">
        <h1>{T.title}</h1>
        {refuse ? (
          <section className="activer__carte">
            <p className="activer__alerte">{T.denied}</p>
            <Link className="activer__btn" to={`/${L}/connexion`}>{T.login}</Link>
          </section>
        ) : (
          <>
            <p>{T.intro}</p>
            {msg && <p className="activer__info" aria-live="polite">{msg}</p>}
            <form className="admin__filtres" onSubmit={(e) => { e.preventDefault(); charger(filtre, q, 1); }}>
              <select value={filtre} onChange={(e) => { setFiltre(e.target.value); charger(e.target.value, q, 1); }} aria-label="filtre">
                <option value="multi">{T.filterMulti}</option>
                <option value="tous">{T.filterAll}</option>
              </select>
              <input value={q} onChange={(e) => setQ(e.target.value)} placeholder={T.search} aria-label={T.search} />
              <button type="submit" className="activer__btn">{T.apply}</button>
            </form>

            {c && (
              <section className="activer__carte admin__compteurs">
                <h2>{T.counters}</h2>
                <p><strong>{c.appareils_multi}</strong> {T.multi} · <strong>{c.lignes}</strong> {T.rows}</p>
                <p className="admin__sources">{(c.par_source || []).map((s) => <span key={s.source} className="admin__badge">{s.source} {s.n}</span>)}</p>
              </section>
            )}

            {liste && liste.status && (
              <div className="admin__pagination">
                <span>{fmt(T.page, { p: liste.page, n: liste.pages, t: liste.total })}</span>
                <button type="button" className="activer__btn activer__btn--second" disabled={liste.page <= 1} onClick={() => charger(filtre, q, page - 1)}>{T.prev}</button>
                <button type="button" className="activer__btn activer__btn--second" disabled={liste.page >= liste.pages} onClick={() => charger(filtre, q, page + 1)}>{T.next}</button>
                <button type="button" className="activer__lien" onClick={() => { const n = { ...sel }; liste.appareils.forEach((a) => { n[a.device_id] = a; }); setSel(n); }}>{T.selectPage}</button>
              </div>
            )}
            {selection.length > 0 && (
              <section className="activer__carte activer__carte--attention admin__groupe">
                <p><strong>{selection.length}</strong> {T.selected} · <button type="button" className="activer__lien admin__inline" onClick={() => setSel({})}>{T.clearSel}</button></p>
                <label htmlFor="adm-bulk">{T.bulkOwner}</label>
                <select id="adm-bulk" value={bulkUser} onChange={(e) => setBulkUser(e.target.value)}>
                  <option value="">—</option>
                  {Object.values(proprietairesSel).map((p) => <option key={p.user_id} value={p.user_id}>{nomDe(p)} ({p.email})</option>)}
                </select>
                <button type="button" className="activer__btn" disabled={!bulkUser} onClick={retraitGroupe}>{T.bulkRemove}</button>
              </section>
            )}
            {liste && liste.status === false && <p className="activer__alerte">{fmt(T.error, { code: liste.raison })}</p>}
            {liste && liste.status && liste.appareils.length === 0 && <p>{T.none}</p>}
            {liste && liste.status && liste.appareils.map((a) => (
              <section key={a.device_id} className="activer__carte admin__appareil">
                <label className="admin__coche">
                  <input type="checkbox" checked={Boolean(sel[a.device_id])} aria-label={`${T.select} ${a.serial_num}`}
                         onChange={(e) => { const n = { ...sel }; if (e.target.checked) n[a.device_id] = a; else delete n[a.device_id]; setSel(n); }} />
                  <h2><span className="admin__sn">{a.serial_num}</span> <small>{a.name}</small></h2>
                </label>
                {a.name_distributer && <p className="admin__meta">{T.distributorField} : {a.name_distributer}</p>}
                <ul className="admin__proprios">
                  {a.proprietaires.map((p) => (
                    <li key={p.user_id}>
                      <div className="admin__qui">
                        <strong>{nomDe(p)}</strong>
                        {p.principal && <span className="admin__badge admin__badge--principal">{T.principal}</span>}
                        <span className={`admin__badge admin__badge--${p.type}`}>{p.type === "distributeur" ? T.distributor : T.client}</span>
                        <span className="admin__badge">{p.source}</span>
                      </div>
                      <div className="admin__meta">{p.email}{p.role ? ` · ${p.role}` : ""}{p.company_name ? ` · ${p.company_name}` : ""} · {p.nb_appareils} {T.devices} · {T.since} {String(p.created_at).slice(0, 10)}</div>
                      <button type="button" className="activer__lien admin__retirer" onClick={() => retirer(a, p)}>{T.remove}</button>
                    </li>
                  ))}
                </ul>
              </section>
            ))}

            <section className="activer__carte">
              <h2>{T.addTitle}</h2>
              <form onSubmit={ajouter}>
                <label htmlFor="adm-sn">{T.addSerial}</label>
                <input id="adm-sn" value={ajout.serial_num} onChange={(e) => setAjout({ ...ajout, serial_num: e.target.value })} />
                <label htmlFor="adm-em">{T.addEmail}</label>
                <input id="adm-em" type="email" value={ajout.email} onChange={(e) => setAjout({ ...ajout, email: e.target.value })} />
                <label htmlFor="adm-mo">{T.motif}</label>
                <input id="adm-mo" value={ajout.motif} onChange={(e) => setAjout({ ...ajout, motif: e.target.value })} />
                <button type="submit" className="activer__btn">{T.add}</button>
              </form>
            </section>

            {c && c.audit && c.audit.length > 0 && (
              <section className="activer__carte">
                <h2>{T.audit}</h2>
                <ul className="admin__audit">
                  {c.audit.map((x, i) => <li key={i}>{String(x.at).slice(0, 16)} · {x.action} · device {x.device_id} · user {x.user_id} · {x.par}{x.motif ? ` · ${x.motif}` : ""}</li>)}
                </ul>
              </section>
            )}

            {etat && etat.status && (
              <section className="activer__carte">
                <h2>{T.campaign}</h2>
                <p><strong>{etat.jetons}</strong> {T.tokens} · <strong>{etat.jetons_utilises}</strong> {T.tokensUsed}</p>
                <h3 className="admin__h3">{T.conversions}</h3>
                <table className="admin__table"><tbody>
                  {(etat.conversions || []).map((x, i) => <tr key={i}><td>{x.verdict}</td><td>{x.raison}</td><td>{x.n}</td></tr>)}
                </tbody></table>
                <h3 className="admin__h3">{T.refusals}</h3>
                <table className="admin__table"><tbody>
                  {(etat.refus_serveur || []).map((x, i) => <tr key={i}><td>{x.etape}</td><td>{x.code_erreur}</td><td>{x.n}</td></tr>)}
                </tbody></table>
              </section>
            )}
          </>
        )}
      </main>
    </>
  );
};

export default AdminProprietaires;
